/* eslint-disable camelcase */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './styles';
import { useState } from 'react';
import { enqueueSnackbar } from '../../store/actions/snackbar';
import { useDispatch } from 'react-redux';

const WellboreImportModal = ({
  onCloseClick,
  isOpen,
  data,
  handleImportClick,
}) => {
  const classes = styles();
  const [mudProfiles, setMudProfiles] = useState('');
  const [importState, setImportState] = useState('Last State');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  return (
        <Dialog
            open={isOpen}
            onClose={onCloseClick}
            maxWidth={isMobile ? 'xs' : 'sm'}
            fullWidth
            fullScreen={isMobile}
            className={classes.dialogModal}
            PaperProps={{
              sx: {
                m: isMobile ? 0 : 2,
                borderRadius: isMobile ? 0 : 2,
              },
            }}
        >
            {/* Header */}
            <Box className={classes.dialogTitle}>
                <Typography variant="subtitle1" className={classes.headerTitle}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="subtitle1" color="textPrimary">
                                {'Wellbore Initialization Import'}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButton onClick={onCloseClick}>
                                <CancelPresentationRounded fontSize="large" />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Typography>
            </Box>

            <Divider />

            {/* Body */}
            <Box sx={{ p: isMobile ? 2 : 3 }}>
                <Grid container spacing={2} direction="column">
                    {/* Dropdown 1 */}
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="textPrimary"
                            sx={{ mb: 1 }}
                        >
                            {'Import From Run'}
                        </Typography>
                        <FormControl
                            variant="filled"
                            className={classes.inputField}
                            fullWidth
                            sx={{ bgcolor: 'transparent' }}
                        >
                            <InputLabel id="run-select-label">Select Run</InputLabel>
                            <Select
                                labelId="run-select-label"
                                id="run-select"
                                value={mudProfiles}
                                onChange={(e) => setMudProfiles(e.target.value)}
                                disableUnderline
                            >
                                {data?.map((item, idItem) => (
                                    <MenuItem
                                        key={`item_${item?.runName}_${idItem}`}
                                        value={item?.runId}
                                    >
                                        {item?.runName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Dropdown 2 */}
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            color="textPrimary"
                            sx={{ mb: 1 }}
                        >
                            {'Import State'}
                        </Typography>
                        <FormControl
                            variant="filled"
                            className={classes.inputField}
                            fullWidth
                            sx={{ bgcolor: 'transparent' }}
                        >
                            <InputLabel id="signal-label">Select Run</InputLabel>
                            <Select
                                labelId="signal-select"
                                id="signal-select"
                                value={importState}
                                onChange={(e) => setImportState(e.target.value)}
                                disableUnderline
                            >
                                {['Initial State', 'Last State']?.map((item, idItem) => (
                                    <MenuItem
                                        key={`item_${item}_${idItem}`}
                                        value={item}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>

            {/* Footer */}
            <Grid
                container
                item
                justifyContent="center"
                margin={isMobile ? '2% 0' : '4% 0'}
            >
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth={isMobile}
                        onClick={() => {
                          if (!mudProfiles) {
                            dispatch(
                              enqueueSnackbar(
                                'Please select a run to import from',
                                'error',
                                Date.now()
                              )
                            );
                            return;
                          }
                          if (importState === 'Initial State' && data.find(
                            (item) => item.runId === mudProfiles && !item.well_init?.pipe?.length && !item?.well_init?.annular?.length
                          )) {
                            dispatch(
                              enqueueSnackbar(
                                'Initial State Not available',
                                'error',
                                Date.now()
                              )
                            );
                            return;
                          }
                          if (importState === 'Last State' && data.find(
                            (item) => item.runId === mudProfiles && item.mud_profile?.profile?.pipe.length === 0 && item.mud_profile?.profile?.annular.length === 0
                          )) {
                            dispatch(
                              enqueueSnackbar(
                                'Last State Not available',
                                'error',
                                Date.now()
                              )
                            );
                            return;
                          }
                          handleImportClick(mudProfiles, importState);
                        }}
                        sx={{
                          width: isMobile ? '100%' : '160px',
                          textTransform: 'none',
                          fontWeight: 'bold',
                        }}
                    >
                        Import
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
  );
};

WellboreImportModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.any,
  handleImportClick: PropTypes.any,
};

export default WellboreImportModal;
